<template>
  <div id="MSLogin">
    <div class="ms-login-header" :class="isPc ? '' : 'font-size-phone'">
      <b>订单管理系统</b>
    </div>
    <div class="ms-login-content">
      <div
        class="ms-login-view"
        :style="{ transform: isPc ? 'scale(1)' : 'scale(2)' }"
      >
        <p class="ms-login-p">用户登录</p>
        <div class="ms-login-scale-input-box">
          <el-form
            :model="userInfo"
            :rules="rules"
            ref="userInfo"
            label-width="auto"
            class="el-form-content"
          >
            <div class="ms-login-input-box">
              <i class="el-icon-s-custom icon-size"></i>
              <el-form-item
                prop="userName"
                style="width: 100%"
                icon="el-icon-s-custom"
              >
                <el-input
                  v-model.trim="userInfo.userName"
                  placeholder="请输入用户名"
                ></el-input>
              </el-form-item>
            </div>
            <div class="ms-login-input-box" style="margin-top: 16px">
              <i class="el-icon-lock icon-size"></i>
              <el-form-item prop="passWord" style="width: 100%">
                <el-input
                  type="password"
                  placeholder="请输入密码"
                  v-model.trim="userInfo.passWord"
                  @keyup.enter.native="submitForm('userInfo')"
                ></el-input>
              </el-form-item>
            </div>
            <div class="ms-login-button">
              <el-button type="primary" @click="submitForm('userInfo')"
                >登录</el-button
              >
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <ms-footer />
  </div>
</template>

<script>
import localMenu from "../assets/js/menu";
export default {
  name: "MSLogin",
  data() {
    return {
      userInfo: {
        userName: "",
        passWord: "",
      },
      rules: {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        passWord: [
          { required: true, message: "请输入用密码", trigger: "blur" },
        ],
      },
      isPc: true,
    };
  },
  created() {
    this.isPc = JSON.parse(sessionStorage.getItem("isPc"));
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login();
        } else {
          this.$message.error("请输入账号和密码");
          return false;
        }
      });
    },

    login() {
      let params = {
        name: this.userInfo.userName,
        // password: this.userInfo.passWord,
        password: this.$md5(this.userInfo.passWord),
      };
      this.$Http.userLogin(params).then((res) => {
        if (res) {
          const { data } = res;
          localStorage.setItem("user", params.name);
          localStorage.setItem("admin_id", data.admin_id);
          this.$message.success("登录成功");

          this.disposeMenus(data.scenics);
          this.$router.replace("/chooseScenic");
        }
      });
    },

    // 处理菜单栏
    disposeMenus(scenics) {
      let allMenus = {};

      scenics.forEach((item, index) => {
        for (let i = 0; i < item.menus.length; i++) {
          let index = localMenu.findIndex(
            (child) => child.name == item.menus[i].menu_name
          );
          item.menus[i].path = localMenu[index].path;
        }

        allMenus[item.scenic_num] = item;
      });

      // let sortMenus = {};  // 如果需要的话这里在排序一次
      // for (let key in menus) {
      //   let menuArr = menus[key];
      //   menuArr.sort((a, b) => {
      //     return a.menu - b.menu;
      //   });

      //   sortMenus[key] = menuArr;
      // }

      localStorage.setItem("scenics", JSON.stringify(scenics));
      localStorage.setItem("permissions", JSON.stringify(allMenus));
    },
  },
};
</script>
<style lang='scss' scoped>
#MSLogin {
  @extend .flex-c;
  position: absolute;
  min-width: 1280px;
  width: 100%;
  height: 100%;
  background-color: rgba(242, 242, 242, 1);
}

.ms-login-header {
  height: 80px;
  background-color: #fff;
  font-size: 26 px;
  line-height: 80px;
  padding-left: 50px;
}

.ms-login-content {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex: 1;
  // min-height: 703px;
  background-color: #fff1dc;
}

.ms-login-view {
  min-width: 452px;
  min-height: 420px;
  max-width: 603px;
  max-height: 560px;
  width: 42%;
  height: 64%;
  background-color: #fff;
  border-radius: 24px;

  .ms-login-p {
    @extend .flex-justify;
    margin-top: 109px;
    font-size: 20px;
    color: #fe8c00;
    font-weight: 500;
  }

  .ms-login-scale-input-box {
    width: 62%;
    max-width: 603px;
    height: 26.92%;
    margin: 41px 0 0 19.07%;
  }
}

/deep/ .el-input--small .el-input__inner {
  height: 40px;
  line-height: 40px;
}

/deep/ .el-form-item--small.el-form-item {
  margin-bottom: 0;
}

.ms-login-button {
  text-align: center;

  button {
    width: 100%;
    height: 36px;
    font-size: 16px;
    margin-top: 54px;
    color: #fff;
    background: #fe8c00;
    border-radius: 20px;
  }
}

// .el-checkbox {
//   color: rgba(0, 0, 0, 0.65);
// }
.ms-login-input-box {
  @extend .flex;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  height: 40px;
  line-height: 40px;

  .icon-size {
    font-size: 22px;
    color: #fe8c00;
    margin-left: 15px;
  }
}

.el-form-content {
  /deep/ .el-input::-webkit-scrollbar-thumb {
    background-color: #fff;
  }

  /deep/ input {
    border: none;
    font-size: 14px;
    font-weight: 400;
  }
}

// /deep/ .el-form-item__error {
//   margin: 8px 0 0 15px;
// }

.font-size-phone {
  font-size: 36px;
}
</style>


// WEBPACK FOOTER //
// src/views/ms-login.vue